import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeDisplayProps {
  homeUuid: string;
  address?: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ homeUuid, address }) => {
  // Construct the correct URL for the main app
  const getAppUrl = () => {
    const origin = window.location.origin;
    if (origin.includes('localhost')) {
      // Development: use localhost:3000
      return 'http://localhost:3000';
    } else if (origin.includes('admin.neverknock.com')) {
      // Production: admin.neverknock.com -> app.neverknock.com
      return 'https://app.neverknock.com';
    } else {
      // Fallback: remove /admin and use same domain
      return origin.replace('/admin', '');
    }
  };
  
  const qrCodeUrl = `${getAppUrl()}/offer/${homeUuid}`;
  
  return (
    <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)', border: '1px solid #e5e7eb' }}>
      <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#111827', marginBottom: '16px' }}>Door QR Code</h3>
      {address && (
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          Address: {address}
        </p>
      )}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
          {homeUuid ? (
            <div style={{ display: 'inline-block', backgroundColor: 'white', padding: '16px', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <QRCodeSVG
                value={qrCodeUrl}
                size={200}
                level="M"
                includeMargin={true}
              />
            </div>
          ) : (
            <div style={{ width: '200px', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
              <span style={{ color: '#6b7280' }}>No UUID available</span>
            </div>
          )}
      </div>
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
          Scan to view home details and interests
        </p>
        <p style={{ fontSize: '12px', color: '#6b7280', wordBreak: 'break-all', fontFamily: 'monospace' }}>
          {qrCodeUrl}
        </p>
        <button
          onClick={async () => {
            try {
              // Import qrcode library for server-side generation
              const QRCode = require('qrcode');
              
              // Generate QR code as data URL
              const dataUrl = await QRCode.toDataURL(qrCodeUrl, { 
                width: 200, 
                margin: 2,
                color: {
                  dark: '#000000',
                  light: '#FFFFFF'
                }
              });
              
              const printWindow = window.open('', '_blank');
              if (printWindow) {
                printWindow.document.write(`
                  <html>
                    <head>
                      <title>QR Code - ${address || 'Home'}</title>
                      <style>
                        body { font-family: Arial, sans-serif; text-align: center; padding: 20px; }
                        .qr-container { margin: 20px 0; }
                        .qr-code { display: inline-block; padding: 20px; border: 1px solid #ccc; }
                        .address { font-size: 14px; color: #666; margin: 10px 0; }
                        .url { font-size: 12px; color: #999; word-break: break-all; }
                      </style>
                    </head>
                    <body>
                      <h2>Door QR Code</h2>
                      ${address ? `<p class="address">${address}</p>` : ''}
                      <div class="qr-container">
                        <div class="qr-code">
                          <img src="${dataUrl}" alt="QR Code" style="width: 200px; height: 200px;" />
                        </div>
                      </div>
                      <p class="url">${qrCodeUrl}</p>
                    </body>
                  </html>
                `);
                printWindow.document.close();
                
                // Wait a moment for the image to load before printing
                setTimeout(() => {
                  printWindow.print();
                }, 100);
              }
            } catch (error) {
              console.error('Error generating QR code:', error);
            }
          }}
          style={{
            marginTop: '16px',
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Print QR Code
        </button>
      </div>
    </div>
  );
};

export default QRCodeDisplay; 